import { render, staticRenderFns } from "./ModalSaveCC.vue?vue&type=template&id=3b812fb0&"
import script from "./ModalSaveCC.vue?vue&type=script&lang=js&"
export * from "./ModalSaveCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports